<template>
  <div class="base-dashboard">
    <template v-if="getDashboardByRole">
      <template v-for="container,key in parseChartList(getDashboardByRole)">
        <BaseContainer
          :key="key"
          :active-spacer="true"
          base-container-classes="mb-4"
        >
          <template v-slot:header-title>
            {{ container.title }}
          </template>
          <template v-slot:header-title-description>
            {{ container.description }}
          </template>
          <template v-slot:header-actions>
            <BaseButton
              v-for="button, btnIndex in container.actions"
              :key="btnIndex"
              type="text"
              color="blueff"
              class="app-button__link-text app-button--hide-ripple app-button--no-hover px-0 text-decoration-underline text-uppercase"
              button-class="app-font-regular"
              @click="onClick(button.action)"
            >
              {{ button.title }}
            </BaseButton>
          </template>
          <v-divider class="mb-8" />
          <div
            v-if="container.filter_date"
            class="app-align-items-center mb-8"
          >
            <v-chip
              class="font-weight-bold mx-1"
              label
              text-color="primary"
              color="secondary"
            >
              <v-icon
                left
                small
              >
                calendar_today
              </v-icon>
              &nbsp; {{ container.filter_date.label }}
            </v-chip>
            <v-tooltip
              v-if="container.filter_date.info"
              bottom
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="primary"
                  dark
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-information
                </v-icon>
              </template>
              <span>{{ container.filter_date.info }}</span>
            </v-tooltip>
          </div>
          <v-row>
            <v-col
              v-for="chart, index in parseChartList(container.charts)"
              :key="index"
              cols="12"
              :md="chart.layout_cols"
              class="pa-0"
            >
              <v-hover v-slot="{ hover }">
                <div
                  class="px-4 py-2 mr-3 mb-4"
                  :style="{'height' : ((chart.layout_rows * 126) + (chart.title ? 46 : 26)) + 'px', 'background' : hover && chart.link ? '#F4F5F8' : '#fff', 'cursor' : chart.link ? 'pointer' : 'default'}"
                  @click="onChartClick(chart.link)"
                >
                  <h3
                    class="mb-2 d-flex"
                    style="color: rgba(0,0,0,.54)"
                  >
                    {{ chart.title }}
                    <v-spacer />
                    <v-icon
                      v-if="hover && chart.link"
                      color="rgba(0,0,0,.54)"
                    >
                      mdi-export
                    </v-icon>
                  </h3>
                  <iframe
                    v-if="showEmbed && getIframeUrl(chart)"
                    width="100%"
                    seamless
                    :height="chart.layout_rows * 126"
                    frameBorder="0"
                    scrolling="yes"
                    :src="getIframeUrl(chart)"
                  />
                </div>
              </v-hover>
            </v-col>
          </v-row>
        </BaseContainer>
      </template>
    </template>
    <div
      v-else
      class="my-12"
    >
      Não há dados para exibir. Utilize os filtros acima para buscar novos dados.
    </div>
  </div>
</template>

<script>
import {mapState, mapActions} from "vuex"
import BaseContainer from './BaseContainer'

export default {
  components: { BaseContainer },
  props:{
    selectedRole: {
      type: String,
      required: true,
      default: null
    },
    selectedProgram: {
      type: Object,
      required: true,
      default: null
    },
    selectedConfigurationId: {
      type: String,
      required: true,
      default: null
    }
  },
  data: () => ({
    dashboardUrlList: {},
    showEmbed: false,
  }),
  computed: {
    ...mapState({
      ticket: state => state.ticket
    }),
    getDashboardByRole(){
      return this.dashboardUrlList[this.selectedRole] ? this.dashboardUrlList[this.selectedRole] : null
    }
  },
  watch: {
    getDashboardByRole: {
      async handler(value) {
        if(value){
          let payload = { program_id: this.selectedProgram.initiator }

          await this.apiGetTicket(payload)
          this.showEmbed = true
        } else {
          this.showEmbed = false
        }
      },
      deep: true
    }
  },
  created(){
    this.getProgramDashboardUrl()
  },
  methods: {
    ...mapActions(["apiGetTicket"]),
    getIframeUrl(chart){
      let heightChart = 126 * chart.layout_rows
      let splitUrl = chart.url.split('?')
      let paramToUrlChart = splitUrl[1] ? `?${splitUrl[1]}` + `&ticket=${this.ticket}&height=${heightChart}` : `?ticket=${this.ticket}&height=${heightChart}`
      let url = splitUrl[0] ? splitUrl[0] + paramToUrlChart : null
      return url
    },
    getProgramDashboardUrl(){
      if(this.selectedProgram && this.selectedProgram.configuration){
        Object.keys(this.selectedProgram.configuration).forEach(key => {
          if(key.includes(this.selectedConfigurationId)){
            let configDashURL = this.selectedProgram.configuration[key]
            this.dashboardUrlList = Object.assign({}, {
              ...this.dashboardUrlList,
              [key.replace(this.selectedConfigurationId, '')]: configDashURL
            })
          }
        })
      }
    },
    parseChartList(value){
      return typeof value === 'string' && value.startsWith('[') ? JSON.parse(value) : value
    },
    onClick(value){
      console.log('click: ', value)
    },
    onChartClick(link){
      if(link) {
        let url = window.location.hostname
        let initiator = this.selectedProgram.initiator.toLowerCase()
        let pathUrl = `https://${initiator}.${url}${link}`

        if(url === 'localhost'){
          window.open(link, '_blank');
        } else {
          window.open(pathUrl, '_blank');
        }
      }
    }
  }
}
</script>
